import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

import type { LibrarySource } from './libraryUtils';

interface Props {
  value: LibrarySource;
  onChange: (source: LibrarySource) => void;
  /** False when Lattice isn't configured — then there is nothing to switch to. */
  latticeAvailable: boolean;
}

const OPTIONS: ReadonlyArray<{ value: LibrarySource; label: string }> = [
  { value: 'coral', label: 'Coral Creator' },
  { value: 'lattice', label: 'Lattice' },
  { value: 'all', label: 'All' },
];

/**
 * Product source switch for the shared SmartAI library: the Coral gallery as it
 * always was, the user's Lattice work, or both. Renders nothing when Lattice is
 * not configured, since Coral would be the only choice.
 */
export const LibrarySourceSwitch: React.FC<Props> = ({ value, onChange, latticeAvailable }) => {
  if (!latticeAvailable) return null;
  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      value={value}
      aria-label="Library source"
      onChange={(_e, next: LibrarySource | null) => {
        if (next) onChange(next);
      }}
    >
      {OPTIONS.map(o => (
        <ToggleButton
          key={o.value}
          value={o.value}
          sx={{ py: 0.25, px: 1.25, textTransform: 'none' }}
        >
          {o.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};
